<template>
  <div class="col-12 picture-post row mx-1">
    <div v-if="files" class="picture">

      <div v-if="isPDF" class="d-flex justify-content-center pt-4">
        <h6><i class="fa fa-file-pdf"></i> PDF</h6>
      </div>

      <div v-else>
        <div class="picture-progress">
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${ progress }%;`"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
            </div>
          </div>
        </div>
        <img :src="filePreview">
      </div>
      <span class="delete-post-image" @click="delImage">
        <small>
          <i class="fas fa-trash text-danger"></i>
        </small>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      default: undefined,
    },
    progress: {
      default: 0,
    }
  },
  watch: {
    files: {
      immediate: true,
      handler: function (val, old) {
        if ( val != undefined && val != old ) {
          if ( val.type.match('image.*') ) {
            this.isPDF = false
            this.loadImagePreview()
          } else {
            this.isPDF = true
          }
        }
      }
    }
  },
  data () {
    return {
      filePreview: '',
      isPDF: false
    }
  },
  methods: {
    loadImagePreview: function () {
      if (!this.files || !this.files.type.match('image.*')) {
        return false
      }

      const reader = new FileReader()

      reader.onload = (e) => {
        this.filePreview = e.target.result
      }

      reader.readAsDataURL(this.files)
    },

    delImage: function () {
      this.$emit('deleteImage')
    }
  }
}
</script>
